const localStorageKey = 'guenoClientKey'

const storeClientKey = (clientKey) => {
  window.localStorage.setItem(localStorageKey, clientKey)
}

const getStoredClientKey = () => {
  return window.localStorage.getItem(localStorageKey)
}

export const cleanStoredClientKey = () => {
  window.localStorage.removeItem(localStorageKey)
}

const getClientKey = async (body) => {
  if (process.env.REACT_APP_ENVIRONMENT === "local") return 'fake-client-key';
  let clientKey = getStoredClientKey()
  if (clientKey) {
    return clientKey
  }
  const urPrelLogin = `${process.env.REACT_APP_MS_IDENTITY_API}/users/user-tenant/pre-login`
  const optionsPreLogin = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }

  await fetch(urPrelLogin, optionsPreLogin)
    .then((res) => res.json())
    .then((res) => {
      if (res.clientKey) {
        clientKey = res.clientKey
        storeClientKey(clientKey)
      } else {
        throw Error('No clientKey to return')
      }
    })

  return clientKey
}

export const getClientKeyWithAccessToken = async (accessToken) => {
  return getClientKey(JSON.stringify({ jwt: accessToken }))
}

export const getClientKeyWithUserPassword = async (userEmail, userPassword) => {
  return getClientKey(JSON.stringify({ email: userEmail, password: userPassword }))
}
